module.exports = __webpack_public_path__ + "img/my_bg_Coupon@3x.2fcf391b.png";